/*
 * Bangle stacks-Charms
 */
var BangleStack = BangleStack || {};
BangleStack.bangleStackModule = function () {
    var bangleSolrSearch, productSelected;
    var itemUtil = {
        getAttrSkuId: function (obj) {
            return obj.attr_sku_id[0];
        },

        inStock: function (obj) {
            var p = 'attr_sku_qty';
            if (obj.hasOwnProperty(p)) {
                return obj[p][this.getSkuKey(obj)].instock;
            } else {
                return false;
            }
        },
        addQtyInfo: function (data) {
            var attr_sku_qty = {};
            for (var i = 0, j = data.productInfo.skuInfos.length; i < j; i++) {
                var sku = data.productInfo.skuInfos[i];
                attr_sku_qty[sku.itemId] = {
                    instock: sku.inStock,
                    quantity: sku.qtyAvailable
                }
            }
            this.attr_sku_qty = attr_sku_qty;
        },
        getProductSelected: function () {
            //Empty the previous selection
            bangleSolrSearch.getOptions().bangleSelected = [];
            var items = $('.list-products li');
            var itemLength = items.length;
            for (var i = 0; i < itemLength; i++) {
                var item = items[i];
                var skuid = item.getAttribute('data-sku');
                var itemClass = item.getAttribute('class');
               bangleSolrSearch.getOptions().bangleSelected.push({skuid: Number(skuid)});
            }
        }
    };
    var bangleRenderer = function () {
        itemUtil.preRender(bangleSolrSearch.solr_data.data.response.docs, 'add-charm');
    };

    /**
     * Function Add To Cart: All the selected bangles together.
     */
    var bangleStack_atc = function () {
        var items = [];
        var linkKey = Math.floor(Math.random() * (1000000 - 1)) + 1;
        var qty = 1;
        var bangleStackSize = bangleSolrSearch.getOptions().bangleSelected.length;
        for (var i = 0; i < bangleStackSize; i++) {
            items.push({
                itemId: bangleSolrSearch.getOptions().bangleSelected[i].skuid,
                quantity: qty,
                linkPrimary: bangleStackSize > 1 && i == 0 ? 't' : 'f',
                linkKey: bangleStackSize > 1 ? linkKey : ''
            });
        }
        addToCart(items, function () {
            updateCartSize();
            $.fancybox.close();
            showCart(true);
        });
        return false;
    };   

    function bangleCallback() {
      
    }

    /*
     * @param bangleSs The bangle 
    */
    var init = function (bangleSs) {
        bangleSs.solr_query.per_page = -1;
        bangleSolrSearch = bangleSs;
        bangleSolrSearch.search();
        // Events when all elements are loaded...
        $(function () {
            $('.btn-add').on('click', function () {
                itemUtil.getProductSelected();
                bangleStack_atc();
            });
        });
    };
    var retObj = {
        init: init,
        bangleRenderer: bangleRenderer,
        bangleCallback: bangleCallback,
        bangleStack_atc: bangleStack_atc
    };
    return retObj;
}();

var Builder = (function ($) {
    function Builder(config) {
        this.settings = config;
        this.charms = [];
        this.charmsHolder = document.querySelector(this.settings.charmsHolderSelector);
        this.init();
    }

    Builder.prototype.init = function () {
        this.bind();
    };
    Builder.prototype.bind = function () {
        var that = this;
        $(this.settings.addCharmSelector).on('click', function (event) {
            event.preventDefault();
            var skuQtyAvailable = $(this).data('qty');
            var currentSkuId = $(this).data('skuid');
            var variantid = $(this).data('variantid'); 
            if (skuQtyAvailable <= 0) {
                return;
            }
            that.addCharm({
                src: this.getAttribute('data-src'),
                price: this.getAttribute('data-price'),
                skuid: this.getAttribute('data-skuid'),
                variantid: this.getAttribute('data-variantid'),
                img: this.getAttribute('data-img-display'),
                final_sale_cat: this.getAttribute('data-final_sale_cat') == 'true',
                final_sale_product_exclude: this.getAttribute('data-final_sale_product_exclude') == 'true'
         
            });
        });
    };

    Builder.prototype.addCharm = function (data) {
        var that = this;
        var position = this.charms.length; 
        var charmToAdd = {
            src: data.src,
            img: data.img,
            price: parseFloat(data.price).toFixed(2),
            skuid: data.skuid,
            variantid: data.variantid,
            position: position,
            final_sale_cat: data.final_sale_cat,
            final_sale_product_exclude: data.final_sale_product_exclude,
            generateElement: function () {
                var charm = this;
                var charmInner = document.createElement('div');
                var removeElement = document.createElement('a');                
                charmInner.className = 'charm-inner';
                this.image = document.createElement('img');
                this.element = document.createElement('div');
                removeElement.className = 'charm-remove';                
                this.image.src = this.img;
                this.element.className = 'charm o-ring charm-position-' + this.position;
                charmInner.appendChild(this.image);
                charmInner.appendChild(removeElement);                
                this.element.appendChild(charmInner);                
                removeElement.addEventListener('click', function(event) {
                    event.preventDefault();
                    charm.remove();
                });
            },
            remove: function() {
                that.charms[this.position] = null;
                that.updateCharms();
                that.updateView();

                // final sale message on removing
                var hasFinalSaleMessage = false;
                for(var i = 0; i < that.charms.length; i++){
                    var bangle = that.charms[i];
                    if(bangle.final_sale_cat && !bangle.final_sale_product_exclude){
                      hasFinalSaleMessage = true;
                    }
                }
                if(!hasFinalSaleMessage){
                    $('.accordion.dyo_final_message').addClass('hidden');
                }
            }
        };
        this.charms.push(charmToAdd);
       //console.log("rrrr", this.charms ); 
        this.charms[position].generateElement();
        // final sale message display
        var hasFinalSaleMessage = false;
        for(var i = 0; i < this.charms.length; i++){
          var bangle = this.charms[i];
          if(bangle.final_sale_cat && !bangle.final_sale_product_exclude){
            hasFinalSaleMessage = true;
          }
        }
        if(hasFinalSaleMessage){
        $('.accordion.dyo_final_message').removeClass('hidden');
        }else{
        $('.accordion.dyo_final_message').addClass('hidden');
        }
        this.updateView();
    };
  
///remove section bangle mid 
    Builder.prototype.updateCharms = function () {     
        var newCharms = [];
        var newPosition = 0;
        for (var i = 0; i < this.charms.length; i++) {
            if (this.charms[i] != null) {
                this.charms[i].position = newPosition;

                newCharms.push(this.charms[i]);
                this.charms[i].element.className = '';
                $(this.charms[i].element).addClass('charm');
                $(this.charms[i].element).addClass('o-ring');
                var newPositionClass = 'charm-position-' + newPosition;
                $(this.charms[i].element).addClass(newPositionClass);
                newPosition++;
            }
        }
        this.charms = newCharms;
    };

    Builder.prototype.updateView = function () {
        var total = 0;
        $(this.charmsHolder).empty();
        $('.list-products').find('.list-products-item').empty().remove();
        var maxBangles = $('.list-products').data('showimage');
        var numBangles = this.charms.length;
        var totals = [0, 75, 125, 165, 195, 225, 255, 280, 305, 330, 350];
        var total = totals[numBangles];
        var baseTotal = 0;
        var pricePer = parseFloat(total / numBangles).toFixed(2);
      for (var i = 0; i < numBangles && i < maxBangles; i++) {
        var bangle = this.charms[i];

        //console.log("rohit", bangle, dataHtml );

var dataHtml = `<li class="list-products-item ctm_allselect_box"  data-charmimgs="${ bangle.img }" data-variantid="${ bangle.variantid }" data-sku="${ bangle.skuid }" data-price="${ bangle.price }">
<div class="list-products-image">
<img crossorigin="anonymous" allowTaint="false" src="${ bangle.src }" alt="">
</div><!-- /.list-products-image -->
<div>
<a href="#" class="link-list-links link-remove" data-sku="${ bangle.skuid }">Remove</a>
</div>
</li>`;

        if (bangle !== null) {
          this.charmsHolder.appendChild(bangle.element);
          bangle.$cartElement = $(dataHtml).data('charm', bangle).appendTo('.list-products');
          baseTotal += parseFloat(this.charms[i].price);
        }
      }

        $('.price .total-value').html(parseFloat(total).toFixed(2));
        $('.base-price .total-value').html(parseFloat(baseTotal).toFixed(2));        
        if(numBangles > 1) {
          $('.base-price').show();
        } else {
          $('.base-price').hide();
        }        
        $('.bangle-count, .selection-count').html(numBangles);        
        if (this.charms.length > 0) {
            $('.js-trigger-modal').removeClass('disable');
            $('.js-trigger-modal').attr('onclick', "event.preventDefault(); $('.modal-added').addClass('active');");
            $('.stack-placeholder').hide();
        } else {
            $('.js-trigger-modal').addClass('disable');
            $('.js-trigger-modal').attr('onclick', null);
            $('.stack-placeholder').show();
        }
        $('body').toggleClass('cant-add-charms', numBangles === 10);
    };
    return Builder;
})(jQuery);

(function ($, window, document, undefined) {
    var $win = $(window);
    var $doc = $(document);
    var isMobileLayout = null;
    $doc.ready(function () {
        $('.list-products').on('click', '.link-remove', function (event) {
            event.preventDefault();
            $(this).closest('li').data('charm').remove();
        });
        var builder = new Builder({
            addCharmSelector: '.add-charm',
            charmsHolderSelector: '.charms',
            contentCharmsImages: '.content .charms-images',
            listProducts: '.list-products'
        });
        $('.accordion-actions .btn-next').on('click', function (event) {
            event.preventDefault();
            var $this = $(this);
            if (!$this.closest('.accordion-section.error').length) {
                $this.closest('.accordion-section').removeClass('accordion-expanded').next('.accordion-section').addClass('accordion-expanded');
                $('.step-error').addClass('hidden');
            } else {
                $('.step-error').removeClass('hidden');
            }
            if ($('.accordion-sections-with-charms').hasClass('accordion-expanded')) {
                $('.charms-images').addClass('show-content')
            } else {
                $('.charms-images').removeClass('show-content')
            }
        });

        $win.on('load', function () {       
            $(document).on('click', '.link-remove', function (event) {
                console.log('remove');
                $('.show-selection-toggle').find('.selection-count').html($('.list-products li').length);
                var skuIdToBeRemoved = $(this).data('sku');
                updateSkuQty(skuIdToBeRemoved);
            });

            function updateSkuQty(skuId) {
                $('.product .add-charm').each(function (idx, value) {
                    if ($(value).data('qty') != undefined) {
                        if ($(value).data('skuid') == skuId) {
                            $(value).data('qty', $(value).data('qty') + 1);
                        }
                    }
                });
            }
        });      

        $(document).on('click', '.link-remove', function (event) {
            event.preventDefault();
            var counter = $('.charms .charm').length;
            if (!($('.list-products li')).length) {
                $('.charms-images-content').removeClass('modified');
            }
            if (counter > 0) {
                $();
                $('.hide-on-click').hide();
            } else {
                $('.hide-on-click').show();
            }
            if (counter < 10) {
                $('.accordion-body').removeClass('overlay')
            }
            $('.show-selection-toggle').find('.selection-count').html($('.list-products li').length);
        });
        var additionalSpace = 47;
      
      });    
})(jQuery, window, document);